var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-text-field',_vm._g(_vm._b({attrs:{"value":_vm.displayValue,"label":_vm.label,"error-messages":_vm.errorMessages,"append-icon":"mdi-calendar"}},'v-text-field',attrs,false),on))]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }